import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "splash-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Forgot E-mail/Resend Confirmation Email")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Forgot Password")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Contact Support")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "btn btn-warning btn-lg w-100 mb-3",
      to: {name: 'Public/Login/ForgotEmail'}
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "btn btn-warning btn-lg w-100 mb-3",
      to: {name: 'Public/Login/ForgotPassword'}
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "btn btn-warning btn-lg w-100",
      to: {name: 'Public/Support'}
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}